import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import {
  CategoryContent,
  CategoryHeader,
  CategoryBack,
  CategoryTitle,
  CategorySearch,
  CategoryAll,
  Category1st,
  Category2nd,
  Category3rd
} from "./CategoryBuilding.styles";

interface Facility {
  id: number;
  name: string;
}

interface Category {
  name: string;
  count: number;
  facilities: Facility[];
}

export default function CategoryBuilding() {
  const [token, setToken] = useState<string>('');
  const [selected1stCategory, setSelected1stCategory] = useState<string>("건물별");
  const [selected2ndCategory, setSelected2ndCategory] = useState<Category | null>(null);
  const [selected3rdCategory, setSelected3rdCategory] = useState<Facility | null>(null);
  const [categories, setCategories] = useState<Category[]>([]);
  const category2ndSelectedRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const topCategories = ["건물별", "테마별"];

  useEffect(() => {
    const storedToken = localStorage.getItem("accessToken");
    if (storedToken) {
      setToken(storedToken);
      console.log(storedToken);
    }
  }, []);

  useEffect(() => {
    if (!token) return;

    const fetchData = async (category: string) => {
      try {
        let url = "http://43.200.254.177:8080/api/v1/facility/category";
        if (category === "건물별") {
          url += "/building";
        } else if (category === "테마별") {
          url += "/theme";
        }
        const response = await axios.get(url, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        if (response.data.isSuccess === true) {
          setCategories(response.data.result.categories);
        } else {
          console.error("서버 응답 오류:", response.data.message);
        }
      } catch (error) {
        console.error("카테고리 데이터를 가져오는 중 오류 발생:", error);
      }
    };
    fetchData(selected1stCategory);
  }, [selected1stCategory, token]);

  useEffect(() => {
    if (category2ndSelectedRef.current && selected2ndCategory) {
      category2ndSelectedRef.current.scrollTo({
        left: category2ndSelectedRef.current.offsetWidth,
        behavior: "smooth"
      });
    }
  }, [selected2ndCategory, selected3rdCategory]);

  const handle1stCategoryClick = (firstCategory: string) => {
    setSelected1stCategory(firstCategory);
    setSelected2ndCategory(null);
    setSelected3rdCategory(null);
  };

  const handle2ndCategoryClick = (category: Category) => {
    if (category.count > 0) {
      setSelected2ndCategory(category);
      setSelected3rdCategory(null);
    }
  };

  const handle3rdCategoryClick = (facility: Facility) => {
    setSelected3rdCategory(facility);
    const id = facility.id;
    navigate('/detailinfo', { state: { id, token } });
  };

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <CategoryContent>
      <CategoryHeader>
        <CategoryBack onClick={handleBackClick}>
          <FontAwesomeIcon
            icon={faChevronLeft}
            style={{ fontSize: '1.5em', color: '#000000' }}
          />
        </CategoryBack>
        <CategoryTitle>카테고리</CategoryTitle>
        <CategorySearch to="/search">
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            style={{ fontSize: '1.5em', color: '#000000' }}
          />
        </CategorySearch>
      </CategoryHeader>
      <CategoryAll ref={category2ndSelectedRef}>
        <Category1st>
          {topCategories.map(category => (
            <div
              key={category}
              onClick={() => handle1stCategoryClick(category)}
              className={selected1stCategory === category ? "active" : ""}
            >
              {category}
            </div>
          ))}
        </Category1st>
        <Category2nd>
          {categories.map(category => (
            <div
              key={category.name}
              onClick={() => handle2ndCategoryClick(category)}
              className={selected2ndCategory?.name === category.name ? "active" : ""}
            >
              {category.name}
            </div>
          ))}
        </Category2nd>
        <Category3rd style={{ display: selected2ndCategory ? 'block' : 'none' }}>
          {selected2ndCategory && selected2ndCategory.count > 0 && selected2ndCategory.facilities.map((facility) => (
            <div key={facility.name} onClick={() => handle3rdCategoryClick(facility)}>
              {facility.name}
            </div>
          ))}
        </Category3rd>
      </CategoryAll>
    </CategoryContent>
  );
}
